<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :visibleCreate="true" :loading="loading" @stored="stored" :visibleStore="updatePermission">
          <template v-slot:action="{ item }">
            <v-btn v-if="updatePermission" class="mr-2" depressed small @click.stop="updated(item)" color="primary">編集</v-btn>
            <v-btn v-if="deletePermission" class="mr-2" depressed small @click.stop="deleted(item)" color="error">削除</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <!-- 削除ボタン押下後に表示されるダイアログ -->
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
        @deleted="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import SuppliersApi from "@/api/suppliers-api";
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CustomDialog from "@/components/custom_ui/CustomDialog";

  export default {
    name: "SuppliersMaster",
    components: {
      CustomDataTable,
      CustomDialog
    },
    props: ["user"],
    data: () => ({
      // 共通コンポーネント: データテーブル関連
      loading: false,
      tableName: '取引先情報',
      headers: [
        { text: '取引先名', value: 'name', sortable: false, align: 'left'},
        { text: '備考', value: 'remarks', sortable: false, align: 'left'},
        { text: 'アクション', value: 'action', sortable: false, align: 'left'},
      ],
      items: [],

      // 削除ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,
      deleteId: null,

      // 権限
      updatePermission: true,
      deletePermission: true
    }),
    created () {
      this.initialize ();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        if (this.user.role_id == 0) {
          this.updatePermission = this.user.permission_config.CTSG00006.update;
          this.deletePermission = this.user.permission_config.CTSG00006.delete;
        }
        this.suppliersApi = new SuppliersApi();
        const promise = this.suppliersApi.list();
        promise.then((response) => {
          this.items = response.data.body.suppliers_list;
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "Dashboard" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },
      // 新規作成ボタン押下時のイベント
      stored () {
        this.$router.push({ name: 'CreateSuppliersMaster' });
      },
      // 編集ボタン押下時イベント
      updated (item) {
        this.$router.push({ name: 'EditSuppliersMaster', params: { id: item.id } });
      },
      // 削除ボタン押下時イベント
      deleted (item) {
        this.deleteId = item.id;
        this.dialogTitle = '削除しますか？';
        this.dialogItems = [
          { name: "取引先名", value: item.name },
          { name: "備考", value: item.remarks }
        ];
        this.dialogDrawer = true;
      },
      dialogCancel () {
        this.dialogDrawer = false;
      },
      // ダイアログ削除ボタン押下時イベント
      submit() {
        this.isLoading();
        // 取引先IDを選択済みアイテム情報から取得
        const promise = this.suppliersApi.delete(this.deleteId);
        promise.then((response) => {
            this.items = this.items.filter((item) => {
                return (item.id !== this.deleteId);
            });
            this.deleteId = null;
            this.dialogDrawer = false;
            this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
    },
  };
</script>
